export const clearCartAction = 'clearCart';
export const returnAndPayAction = 'returnAndPay';
